import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './components/SignIn';
import DashboardSelection from './components/DashboardSelection';
import DashboardLayout from './pages/DashboardLayout';
import AdminDashboard from './pages/Dashboard';
import MarathiDashboard from './pages/MarathiDashboard';
import englishService from './services/englishService';
import SpeechManagement from './pages/SpeechesUpload';
import ArticleManagement from './pages/ArticleUpload';
import NewsManagement from './pages/NewsUpload';
import EventManagement from './pages/EventsUpload';
import InterviewManagement from './pages/InterviewsUpload';
import SccnMessageManagement from './pages/SCCNMessegesUpload';
import ProjectManagement from './pages/ProjectsUpload';
import Comments from './pages/Comments';
import ExportData from './pages/ExportUpload';
import BlogManagement from './pages/BlogUpload';
import OvenfreshUpload from './pages/OvenFreshUpload';
import ViewSubscribers from './pages/ViewSubscribers';
import MarathiDashboardLayout from './pages/MarathiDashboardLayout';
import MarathiQuotes from './pages/marathiblogs/MarathiQuotes';
import MarathiArticles from './pages/marathiblogs/MarathiArticles';
import MarathiBlogs from './pages/marathiblogs/MarathiBlogs';
import MarathiInfomatics from './pages/marathiblogs/MarathiInfomatics';
import MarathiSpeeches from './pages/marathiblogs/MarathiSpeeches';
import MarathiComments from './pages/marathiblogs/MarathiComments';
import MarathiSubscribers from './pages/marathiblogs/MarathiSubscribers';
import MarathiVideoGallery from './pages/marathiblogs/MarathiVideoGallery';
import MarathiPhotoGallery from './pages/marathiblogs/MarathiPhotoGallery';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = englishService.auth.isAuthenticated();
  return isAuthenticated ? children : <Navigate to="/admin-login" replace />;
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = englishService.auth.isAuthenticated();
  return !isAuthenticated ? children : <Navigate to="/dashboard-selection" replace />;
};

const App = () => {
  const handleLogout = () => {
    englishService.auth.logout();
    window.location.href = '/admin-login';
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard-selection" replace />} />

        <Route
          path="/admin-login"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />

        <Route
          path="/dashboard-selection"
          element={
            <ProtectedRoute>
              <DashboardSelection />
            </ProtectedRoute>
          }
        />

        {/* Main English Dashboard */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <DashboardLayout onLogout={handleLogout}>
                <Routes>
                  <Route index element={<AdminDashboard />} />
                  <Route path="blogs" element={<BlogManagement />} />
                  <Route path="speeches" element={<SpeechManagement />} />
                  <Route path="news" element={<NewsManagement />} />
                  <Route path="articles" element={<ArticleManagement />} />
                  <Route path="events" element={<EventManagement />} />
                  <Route path="interviews" element={<InterviewManagement />} />
                  <Route path="projects" element={<ProjectManagement />} />
                  <Route path="messages" element={<SccnMessageManagement />} />
                  <Route path="marathiblogs" element={<Navigate to="/marathi-dashboard" replace />} />
                  <Route path="ovenfresh" element={<OvenfreshUpload />} />
                  <Route path="subscribers" element={<ViewSubscribers />} />
                  <Route path="comments" element={<Comments />} />
                  <Route path="export" element={<ExportData />} />
                  {/* <Route path="photos" element={<PhotoGallery />} />
                  <Route path="videos" element={<VideoGallery />} /> */}
                  <Route path="*" element={<div>404 - Not Found</div>} />
                </Routes>
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Marathi Dashboard */}
        <Route
          path="/marathi-dashboard/*"
          element={
            <ProtectedRoute>
              <MarathiDashboardLayout onLogout={handleLogout}>
                <Routes>
                  <Route index element={<MarathiDashboard />} />
                  <Route path="quotes" element={<MarathiQuotes />} />
                  <Route path="articles" element={<MarathiArticles />} />
                  <Route path="blogs" element={<MarathiBlogs />} />
                  <Route path="infomatics" element={<MarathiInfomatics />} />
                  <Route path="speeches" element={<MarathiSpeeches />} />
                  <Route path="photos" element={<MarathiPhotoGallery />} />
                  <Route path="videos" element={<MarathiVideoGallery />} />
                   <Route path="subscribers" element={<MarathiSubscribers />} />
                <Route path="comments" element={<MarathiComments />} />
                  <Route path="*" element={<div>404 - Not Found</div>} />
                </Routes>
              </MarathiDashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/admin-login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;